import { useQuery, gql } from '@apollo/client';

export function useDataPointSubQuerys({ yearStart, yearEnd, weekStart, weekEnd }) {
  const variables = { yearStart, yearEnd, weekStart, weekEnd };
  const { data = {}, loading } = useQuery(GET_SUBQUERY, {
    variables,
    skip: skip(variables),
  });
  return { loading, data: { Subqueries: data.Subqueries } };
}

function skip(variables) {
  let skip = true;
  let { yearStart, yearEnd, weekStart, weekEnd } = variables;
  skip = ![yearStart, yearEnd, weekStart, weekEnd].every((v) => v);
  return skip;
}

const GET_SUBQUERY = gql`
  query ResponsesDataPointsRangeSubqueries(
    $yearStart: Int!
    $yearEnd: Int!
    $weekStart: Int!
    $weekEnd: Int!
  ) {
    Subqueries: ResponsesDataPointsRangeSubqueries(
      yearStart: $yearStart
      yearEnd: $yearEnd
      weekStart: $weekStart
      weekEnd: $weekEnd
    ) {
      _id
      groupData {
        users
        devices
        dates
        hours
      }
      users
      devices
      dates
      hours
    }
  }
`;
